import type {FC} from "react";

import {Link} from "react-router";
import type {StepWizardChildProps} from "react-step-wizard";

import {chooseBuildingType} from "../../actions";
import {AppRoutes} from "../../App";
import {useAppDispatch, useAppSelector} from "../../hooks";
import {
  BUILDING_TYPE_BLOCK,
  BUILDING_TYPE_DETACHED,
  BUILDING_TYPE_DUPLEX,
  BUILDING_TYPE_TERRACED,
  type BuildingType,
  type PlanState
} from "../../reducers/types";
import {useWizardNavigation} from "../../utils/app-utils";


/**
 * Wizard building type selection step component.
 */
export const BuildingTypeSelection: FC<Partial<StepWizardChildProps>> = (props) => {
  const dispatch = useAppDispatch()
  const plan = useAppSelector<PlanState>((state) => state.plan)
  const navigation = useWizardNavigation(props)

  const primaryButtonClass = 'btn-primary'
  const whiteButtonClass = 'btn-white'

  const chooseBuilding = (buildingType: BuildingType) => {
    dispatch(chooseBuildingType(buildingType))
    navigation.nextStep()
  }

  return (
    <div>
      <h4 className='mb-4'>Taloyhtiön tyyppi</h4>
      <div className='row mb-4'>
        <div className='col-6'>
          <button
            data-testid='building-block'
            className={`btn btn-block left p-4  ${plan.buildingType === BUILDING_TYPE_BLOCK
              ? primaryButtonClass
              : whiteButtonClass}`}
            onClick={() => {
              chooseBuilding(BUILDING_TYPE_BLOCK)
            }}
            style={{textAlign: 'left'}}
          >
            <i className='fas fa-building fa-5x mr-4' style={{color: '#d2ddec', float: 'right'}}/>
            <span className='ml-2'>Kerrostalo</span>
          </button>
        </div>
        <div className='col-6'>
          <button
            data-testid='building-terraced'
            className={`btn btn-block left p-4  ${plan.buildingType === BUILDING_TYPE_TERRACED
              ? primaryButtonClass
              : whiteButtonClass}`}
            onClick={() => {
              chooseBuilding(BUILDING_TYPE_TERRACED)
            }}
            style={{textAlign: 'left'}}
          >
            <i className='fas fa-city fa-5x mr-4' style={{color: '#d2ddec', float: 'right'}}/>
            <span className='ml-2'>Rivitalo</span>
          </button>
        </div>
      </div>
      <div className='row'>
        <div className='col-6'>
          <button
            data-testid='building-duplex'
            className={`btn btn-block left p-4  ${plan.buildingType === BUILDING_TYPE_DUPLEX
              ? primaryButtonClass
              : whiteButtonClass}`}
            onClick={() => {
              chooseBuilding(BUILDING_TYPE_DUPLEX)
            }}
            style={{textAlign: 'left'}}
          >
            <i className='fas fa-home fa-5x mr-4' style={{color: '#d2ddec', float: 'right'}}/>
            <span className='ml-2'>Paritalo</span>
          </button>
        </div>
        <div className='col-6'>
          <button
            data-testid='building-detached'
            className={`btn btn-block left p-4  ${plan.buildingType === BUILDING_TYPE_DETACHED
              ? primaryButtonClass
              : whiteButtonClass}`}
            onClick={() => {
              chooseBuilding(BUILDING_TYPE_DETACHED)
            }}
            style={{textAlign: 'left'}}
          >
            <i className='fas fa-home fa-5x mr-4' style={{color: '#d2ddec', float: 'right'}}/>
            <span className='ml-2'>Erillistalo</span>
          </button>
        </div>
      </div>
      <Link to={AppRoutes.home} className='btn btn-default mt-4'>Palaa alkuun</Link>
    </div>
  )
}
